
import { Brand, AnalyticsChartConfigs } from 'lib/types';
import {
	personCenter,
	configuredStart,
	unConfiguredData,
	sfCenter,
	unConfiguredStart, 
	start2, 
	start3,
	start4,
	start4Cooking,
	start5,
	noMulesoftDataBrunello, 
	dataCenter,
	withPOSData
} from 'data/constellations';

// const dateOptions = {month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'};
// const yesterday = new Date(Date.now() - 86400000);
// const lastModified = yesterday.toLocaleString('en-US', dateOptions);

const brunelloStartMoons = JSON.parse(JSON.stringify(configuredStart.slice(0, 5)));
brunelloStartMoons[1].rotation = 60;
brunelloStartMoons[2].rotation = 120;
brunelloStartMoons[3].rotation = 180;
brunelloStartMoons[4].rotation = 270;

const chartConfig = {
	axesLabelSuffix: 'K',
	axesColor: '#DDDBDA',
	barHeight: 25,
	barPadding: 10,
	barValueY: 5,
	barValueX: 4,
	height: '100%',
	labelWidth: 170,
	logScale: true,
	topPadding: 70,
	width: '100%',
	uniquesAnimateDelay: 550,
	uniquesLabel: 'Customer 360 IDs',
	units: 'K'
};

const mulesoftChart: AnalyticsChartConfigs = {
	chart: chartConfig,
	data: [
		{
			cloud: 'marketing', name: 'US Midwest Marketing',
			totalCount: '18K', uniqueCount: '9K'
		},
		{
			cloud: 'service', name: 'US Midwest Service',
			totalCount: '63K', uniqueCount: '37K'
		},
		{
			cloud: 'retail', name: 'US Midwest Retail',
			totalCount: '16K', uniqueCount: '5K'
		}
	],
	totalsLabel: 'Input Customer Records',
	uniquesLabel: 'Customer 360 IDs',
};

const emptyChart = JSON.parse(JSON.stringify(mulesoftChart));
emptyChart.data = emptyChart.data.slice(0, 0);
emptyChart.isEmpty = true;

const firstChart = JSON.parse(JSON.stringify(mulesoftChart));
firstChart.data = firstChart.data.slice(1, 2); 
firstChart.animateTotals = true;
firstChart.animateUniques = true;
firstChart.isEmpty = false;

const secondChart = JSON.parse(JSON.stringify(mulesoftChart));
secondChart.data = secondChart.data.slice(0, 2);
secondChart.animateTotals = true; 
firstChart.animateUniques = true;
secondChart.isEmpty = false;

const thirdChart = JSON.parse(JSON.stringify(mulesoftChart));
thirdChart.data = thirdChart.data.slice(0, 3); 
thirdChart.animateTotals = true;
firstChart.animateUniques = true;
thirdChart.isEmpty = false;

const cookingShowChart: AnalyticsChartConfigs = {
	chart: chartConfig,
	data: [
		{
			cloud: 'marketing', name: 'US Midwest Marketing',
			totalCount: '63K', uniqueCount: '37K'
		},
		{
			cloud: 'service', name: 'US Midwest Service',
			totalCount: '18K', uniqueCount: '9K'
		},
		{
			cloud: 'retail', name: 'US Midwest Retail',
			totalCount: '16K', uniqueCount: '5K'
		},
		{
			cloud: 'marketing', name: 'US Northeast Marketing',
			totalCount: '18K', uniqueCount: '10K'
		},
		{
			cloud: 'service', name: 'US Northeast Service',
			totalCount: '6K', uniqueCount: '3K'
		},
		{
			cloud: 'retail', name: 'US Northeast Retail',
			totalCount: '8K', uniqueCount: '4K'
		},
		{
			cloud: 'mulesoft', name: 'SAP API',
			totalCount: '50K', uniqueCount: '20K'
		}

	],
	totalsLabel: 'Input Customer Records',
	uniquesLabel: 'Customer 360 IDs',
};

const thirdChartCookingShow = JSON.parse(JSON.stringify(cookingShowChart));
thirdChartCookingShow.data = thirdChartCookingShow.data.slice(0, 6); 
thirdChartCookingShow.animateTotals = true;
firstChart.animateUniques = true;
thirdChartCookingShow.isEmpty = false;

const fourthChart = JSON.parse(JSON.stringify(cookingShowChart));
fourthChart.data = fourthChart.data.slice(0, 6); 
fourthChart.animateTotals = true;
firstChart.animateUniques = true;
fourthChart.isEmpty = false;

// const secondChart = JSON.parse(JSON.stringify(mulesoftChart));
// secondChart.data = secondChart.data.slice(0, 6); // Final w/o MuleSoft
// secondChart.animateTotals = true;

// const finalChart = JSON.parse(JSON.stringify(mulesoftChart));
// Object.assign(finalChart.data[0], {uniqueCount: '12K'});
// Object.assign(finalChart.data[1], {uniqueCount: '8.1K'});
// Object.assign(finalChart.data[2], {uniqueCount: '9K'});
// Object.assign(finalChart.data[3], {uniqueCount: '31K'});
// Object.assign(finalChart.data[4], {uniqueCount: '7K'});
// Object.assign(finalChart.data[5], {uniqueCount: '28K'});
// Object.assign(finalChart.data[6], {uniqueCount: '89.2K'});
// finalChart.animateUniques = true;
// secondChart.animateTotals = true;

/*
 * THE BRAND
 */

const df18Brunello: Brand = {
	dashboard: {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {
				constellations: [
					{center: sfCenter, moons: unConfiguredData},
					{center: personCenter, moons: unConfiguredStart}
				],
				interaction: 'empty',
				nextClick: [0, 5],
				start: 1
			},
			source: {
				icon: 'service-circle', name: 'NTO Service', type: 'Service Cloud',
				domain: 'https://shop.brunellocucinelli.com/en-us/', production: 'True',
				src: ['/assets/icons/service-circle-big.svg', 'serviceBackground']
			},
			chart: emptyChart
		}
	},
	'dashboard-auth1': {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {
				constellations: [
					{center: sfCenter, moons: unConfiguredData},
					{center: personCenter, moons: brunelloStartMoons}
				],
				interaction: 'empty',
				nextClick: [0, 2],
				start: 0
			},
			chart: emptyChart,
			source: {
				icon: 'service-circle', name: 'US Midwest Service', type: 'Service Cloud',
				domain: 'https://shop.brunellocucinelli.com/en-us/', production: 'True', 
				src: ['/assets/icons/service-circle-big.svg', 'serviceBackground']
			}
		}
	},
	dashboard2: {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {
				constellations: [
					{center: sfCenter, moons: unConfiguredData},
					{center: personCenter, moons: start2}
				],
				interaction: 'empty',
				nextClick: [0, 1],
				start: 1
			},
			chart: firstChart
		}
	}, 
	'dashboard-auth2': {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {
				constellations: [
					{center: sfCenter, moons: unConfiguredData},
					{center: personCenter, moons: brunelloStartMoons}
				],
				interaction: 'empty',
				nextClick: [0, 2],
				start: 0
			},
			chart: firstChart,
			source: {
				icon: 'marketing-circle', name: 'US Midwest Marketing', type: 'Marketing Cloud',
				domain: 'https://shop.brunellocucinelli.com/en-us/', production: 'True',
				src: ['/assets/icons/marketing-circle-big.svg', 'marketingBackground']
			}
		}
	},
	dashboard3: {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {
				constellations: [
					{center: sfCenter, moons: unConfiguredData},
					{center: personCenter, moons: start3}
				],
				interaction: 'empty',
				nextClick: [0, 2],
				start: 1
			},
			chart: secondChart
		}
	}, 
	'dashboard-auth3': {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {
				constellations: [
					{center: sfCenter, moons: unConfiguredData},
					{center: personCenter, moons: brunelloStartMoons}
				],
				interaction: 'empty',
				nextClick: [0, 2],
				start: 0
			},
			chart: secondChart,
			source: {
				icon: 'commerce-circle', name: 'US Midwest Commerce', type: 'Commerce Cloud',
				domain: 'https://shop.brunellocucinelli.com/en-us/', production: 'True',
				src: ['/assets/icons/commerce-circle-big.svg', 'commerceBackground']
			}
		}
	},
	dashboard4: {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {
				constellations: [
					{center: personCenter, moons: start4},
					{center: dataCenter, moons: noMulesoftDataBrunello}
				],
				interaction: 'mulesoft',
				start: 0
			},
			chart: thirdChart, 
			mulesoft: {
				api: 'MuleSoft API',
				cards: [
					{icon: '/assets/images/mulesoft/workday.png', iconWidth: 44, industry: 'IT', name: 'Employee Profile Process API'},
					{icon: '/assets/images/SAP_new.png', iconWidth: 25, industry: 'IT', name: 'SAP API'},
					{icon: '/assets/images/mulesoft/ibm.png', iconWidth: 44, industry: 'Manufacturing', name: 'Inventory Process API'},
					{industry: 'IT', name: 'Composite Customer Profile Process API'},
					{icon: 'identity', industry: 'IT', name: 'Customer Onboarding Process API'},
					{icon: 'people', industry: 'Sales', name: 'Customer Membership API'},
					{industry: 'ISV',  name: 'Partners Process API'},
					{icon: '/assets/images/mulesoft/postgresql.svg', iconWidth: 24, industry: 'IT', name: 'Order Process API'},
				],
				cardInfo: {
					description: `
						This API brings in Point-of-Sale order information from the Point-of-Sale
						system and transforms it into canonical for Salesforce Customer 360.
					`,
					imageSource: '/assets/images/mulesoft-pos-order.svg',
					title: 'Retail API'
				}
			}
		}
	}, 
	dashboard4CookingShow: {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {

				constellations: [
					{center: personCenter, moons: start4Cooking},
					{center: dataCenter, moons: noMulesoftDataBrunello}
				],
				interaction: 'mulesoft',
				start: 0
			},
			chart: thirdChartCookingShow, 
			mulesoft: {
				api: 'MuleSoft API',
				cards: [
					{icon: '/assets/images/mulesoft/workday.png', iconWidth: 44, industry: 'IT', name: 'Employee Profile Process API'},
					{icon: '/assets/images/SAP_new.png', iconWidth: 25, industry: 'IT', name: 'SAP API'},
					{icon: '/assets/images/mulesoft/ibm.png', iconWidth: 44, industry: 'Manufacturing', name: 'Inventory Process API'},
					{industry: 'IT', name: 'Composite Customer Profile Process API'},
					{icon: 'identity', industry: 'IT', name: 'Customer Onboarding Process API'},
					{icon: 'people', industry: 'Sales', name: 'Customer Membership API'},
					{industry: 'ISV',  name: 'Partners Process API'},
					{icon: '/assets/images/mulesoft/postgresql.svg', iconWidth: 24, industry: 'IT', name: 'Order Process API'},
				],
				cardInfo: {
					description: `
						This API brings in Point-of-Sale order information from the Point-of-Sale
						system and transforms it into canonical for Salesforce Customer 360.
					`,
					imageSource: '/assets/images/mulesoft-pos-order.svg',
					title: 'Retail API'
				}
			}
		}
	},
	dashboard5: {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {
				constellations: [
					{center: personCenter, moons: start5},
					{center: dataCenter, moons: withPOSData}
				],
				interaction: 'other',
				start: 1
			},
			chart: cookingShowChart
		}
	},
	home: {
		guide: null,
		dashboard: {
			configured: true,
			einstein: false
		},
		data: {
			card: {
				constellations: [
					{center: sfCenter, moons: unConfiguredData},
					{center: personCenter, moons: start5}
				],
				interaction: 'empty',
				nextClick: [0, 2],
				start: 1
			},
			chart: fourthChart
		}
	}, 
};

export default df18Brunello;



// WEBPACK FOOTER //
// ./src/brands/df18Brunello.ts